@if (isFullPageComponent) {
  <ng-container *ngTemplateOutlet="crmListContent"></ng-container>     
}

@else {
  <div class="modal fade" id="crmPickerModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="importsModalLabel">Choose Your CRM</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <ng-container *ngTemplateOutlet="crmListContent"></ng-container>     
      </div>
    </div>
  </div>
}


<ng-template #crmListContent>
  <div class="modal-body p-5">
    <div class="d-flex flex-wrap flex-gap-1" [ngClass]="isFullPageComponent ? 'justify-content-center':'justify-content-between'">
      @for (crm of crmList; track $index) {        
      <a href="/crm/{{crm.crmType}}" class="zint-base-card zint-card-gradient-light">
        <img src="https://www.google.com/s2/favicons?sz=64&domain={{crm.name}}.com" width="24" alt="crm logo">
        <span class="ms-1">{{crm.name}}</span>
      </a>
      }
    </div>
  </div>
</ng-template>